import { createContext, useState, useContext, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var TestAudioContext = /*#__PURE__*/createContext(undefined);
export var AudioProvider = function AudioProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      currentlyPlayingId = _useState[0],
      setCurrentlyPlayingId = _useState[1];

  var _useState2 = useState(new Set()),
      skippedSectionIds = _useState2[0],
      setSkippedSectionIds = _useState2[1];

  var _useState3 = useState(new Set()),
      endedAudioIds = _useState3[0],
      setEndedAudioIds = _useState3[1];

  var _useState4 = useState(new Map()),
      audioReplays = _useState4[0],
      setAudioReplays = _useState4[1];

  var playAudio = useCallback(function (audioId) {
    setCurrentlyPlayingId(audioId);
  }, [endedAudioIds]);
  var isAudioDisabled = useCallback(function (audioId) {
    return endedAudioIds.has(audioId);
  }, [endedAudioIds]);
  var markAsEnded = useCallback(function (audioId) {
    if (currentlyPlayingId === audioId) {
      setCurrentlyPlayingId(null); // setEndedAudioIds(prev => new Set(prev).add(audioId));
    }
  }, [currentlyPlayingId]);
  var skippedAudio = useCallback(function (audioId) {
    // Add the audio to the skipped list
    setEndedAudioIds(function (prev) {
      return new Set(prev).add(audioId);
    });
    setSkippedSectionIds(function (prev) {
      return new Set(prev).add(audioId);
    });
  }, []);
  var onEnded = useCallback(function (audioId) {
    // If the audio is currently playing, mark it as ended
    if (currentlyPlayingId === audioId) {
      markAsEnded(audioId);
    }

    skippedAudio(audioId);
  }, [currentlyPlayingId, markAsEnded, skippedAudio]); // Audio replay management methods

  /** Always set replay budget so updates (e.g. after stats load) replace stale values. */

  var initializeAudioReplays = useCallback(function (audioId, numberOfReplays) {
    setAudioReplays(function (prev) {
      var newMap = new Map(prev);
      newMap.set(audioId, numberOfReplays);
      return newMap;
    });
  }, []);
  var getRemainingReplays = useCallback(function (audioId) {
    var n = audioReplays.get(audioId);
    return n === undefined ? 0 : n;
  }, [audioReplays]);
  var decrementReplays = useCallback(function (audioId) {
    var remainingReplays = 0;
    setAudioReplays(function (prev) {
      var newMap = new Map(prev);
      var current = newMap.get(audioId) || 0;
      remainingReplays = Math.max(0, current - 1);
      newMap.set(audioId, remainingReplays);
      return newMap;
    });
    return remainingReplays;
  }, []);
  var value = {
    // State
    currentlyPlayingId: currentlyPlayingId,
    skippedSectionIds: skippedSectionIds,
    audioReplays: audioReplays,
    // Methods
    isAudioDisabled: isAudioDisabled,
    playAudio: playAudio,
    markAsEnded: markAsEnded,
    skippedAudio: skippedAudio,
    onEnded: onEnded,
    initializeAudioReplays: initializeAudioReplays,
    getRemainingReplays: getRemainingReplays,
    decrementReplays: decrementReplays
  };
  return /*#__PURE__*/_jsx(TestAudioContext.Provider, {
    value: value,
    children: children
  });
};
export var useTestAudio = function useTestAudio() {
  var context = useContext(TestAudioContext);

  if (!context) {
    throw new Error('useTestAudio must be used within an AudioProvider');
  }

  return context;
};